import { createContext, useContext } from "react";
import type { Branding } from "../api/types";
import { deriveBrandPalette, type BrandPalette } from "../theme";

export interface BrandingContextValue {
  branding: Branding | null;
  palette: BrandPalette;
}

const BrandingContext = createContext<BrandingContextValue>({
  branding: null,
  palette: deriveBrandPalette(null),
});

export const BrandingProvider = BrandingContext.Provider;

/** Tenant branding + derived palette, provided by TenantLayout. */
export function useBranding(): BrandingContextValue {
  return useContext(BrandingContext);
}
